import React, { useEffect, useState } from "react";
import SearchIcon from "@material-ui/icons/Search";
import { InputAdornment } from "@material-ui/core";
import { CustomTextField } from "containers/gstr2a2bNewEnhancement/Utility/utility";
import downloadWhite from "images/downloadWhite.svg";
import { Button } from "@material-ui/core";
import "../../../../style.css";
import Table from "./Table";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import { Typography } from "@material-ui/core";
import { months } from "./../../../constants";
import CustomSelect from "containers/gstr2a2bNewEnhancement/Utility/CustomSelect";
import { useDispatch, useSelector } from "react-redux";
import {
  reset3bAction,
  getRecoTablesData,
  mark3bStatus,
  setSelectedMatched,
  getReset,
  setSearchStr,
  setPageNoMatched,
} from "containers/gstr2a2bNewEnhancement/Reconciliation/action";
import { errorToastMessage } from "utils/errorToast";
import { COMMON_MSGS } from "Constant/Messages";
import SelectMonth from "../SelectMonth";

const Matched = (props) => {
  const dispatch = useDispatch();
  const {
    selectedMatched,
    activeTabReco,
    activeTabViewReco,
    activeTabDocView,
    dateRange,
    selection: select,
    recoSelection,
    selectedYear,
    selectedRowMatched,
    searchStr,
  } = useSelector((store) => store.gstr2a2bNewRecoReducer);
  const { selectedGstin } = useSelector(
    (store) => store.gstr2a2bNewCommonReducer
  );
  const [open3b, setOpen3b] = useState(false);
  const [selection, setSelection] = useState("");
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const handleMarkin3b = () => {
    if (selectedMatched?.length === 0) {
      return errorToastMessage(COMMON_MSGS.SELECT_RECORD);
    }
    console.log("handleMarkin3b called");
    setOpen3b(true);
  };
  const handleChange = (event) => {
    setSelection(event.target.value);
  };
  const handleSubmit = async () => {
    if (selectedMatched?.length === 0) {
      return errorToastMessage(COMMON_MSGS.SELECT_RECORD);
    }
    await dispatch(
      mark3bStatus(selectedMatched, selection, selectedRowMatched)
    );

    await props.handleSubmit(false, 1);
    dispatch(setPageNoMatched(1))
    dispatch(setSelectedMatched([]));
    setOpen3b(false);
  };

  const handleReset3bAction = async () => {
    if (selectedMatched?.length === 0) {
      return errorToastMessage(COMMON_MSGS.SELECT_RECORD);
    }
    await dispatch(reset3bAction(selectedMatched, selectedRowMatched));
    await props.handleSubmit(false, 1);
    dispatch(setSelectedMatched([]));
    // await dispatch(
    //   getRecoTablesData(
    //     selectedGstin,
    //     select,
    //     recoSelection,
    //     selectedYear,
    //     dateRange,
    //     activeTabReco,
    //     activeTabViewReco,
    //     activeTabDocView
    //   )
    // );
  };

  const handleReset = async () => {
    if (selectedMatched?.length === 0) {
      return errorToastMessage(COMMON_MSGS.SELECT_RECORD);
    }
    await dispatch(getReset(selectedMatched, selectedRowMatched));
    await props.handleSubmit(false, 1);
    dispatch(setSelectedMatched([]));
  };

  useEffect(() => {
    return () => {
      console.log("Matched unmount search cleared");
      dispatch(setSearchStr(""));
    };
  }, []);

  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-start" }}>
        <div style={{ width: "35%", marginTop: "0.3em" }}>
          <CustomTextField
            style={{ backgroundColor: "white" }}
            placeholder="Search"
            className="custom-search-field"
            variant="outlined"
            size="small"
            value={searchStr}
            onChange={props.handleInputChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <Button
          onClick={() => props.handleDownload("Matched")}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "0.8em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
          }}
        >
          <img
            src={downloadWhite}
            alt="Download"
            style={{
              width: "30px",
              height: "20px",
              paddingBottom: "3px",
            }}
          />
        </Button>
        <Button
          onClick={props.handleOpen}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "0.8em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
            // paddingLeft:'3em',
            // paddingRight:'3em'
          }}
        >
          Filter
        </Button>
        <Button
          onClick={handleMarkin3b}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "0.8em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
          }}
        >
          Mark in 3B
        </Button>
        <Button
          onClick={handleReset3bAction}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "0.8em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
          }}
        >
          Reset 3B Action
        </Button>
        <Button
          onClick={handleReset}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "0.8em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
            // paddingLeft:'3em',
            // paddingRight:'3em'
          }}
        >
          Reset
        </Button>
      </div>

      <Table
        handlePageClick={props.handlePageClick}
        handleSubmit={props.handleSubmit}
      />
      <Dialog
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        // maxWidth={isDatePickerOpen ? "sm" : "xs"}
        maxWidth={"xs"}
        open={open3b}
        PaperProps={{
          style: {
            minHeight: isDatePickerOpen ? "275px" : "auto",
            transition: "all 0.3s ease-in-out",
          },
        }}
      >
        <MuiDialogTitle
          disableTypography
          style={{ color: "#4f2d7f", backgroundColor: "white" }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div></div>
            <Typography variant="h6">{"Mark in 3B"}</Typography>
            <CloseIcon
              onClick={() => setOpen3b(false)}
              style={{ cursor: "pointer" }}
            />
          </div>
        </MuiDialogTitle>
        <MuiDialogContent dividers>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Typography style={{ marginTop: "3px" }}>
              {"Selected Month :"}
            </Typography>
            &nbsp;
            {/* <CustomSelect
              values={months}
              optionHeading={"Select Month"}
              selectedValue={selection}
              setSelectedValue={setSelection}
              handleChange={handleChange}
            /> */}
            <SelectMonth
              selection={selection}
              setSelection={setSelection}
              onCalendarOpen={() => setIsDatePickerOpen(true)}
              onCalendarClose={() => setIsDatePickerOpen(false)}
            />
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              onClick={handleSubmit}
              type="submit"
              variant="contained"
              color="primary"
              style={{
                backgroundColor: "#4f2d7f",
                color: "white",
                marginTop: "0.8em",
                marginLeft: "1em",
                height: "32px",
                fontSize: "12px",
                textTransform: "capitalize",
              }}
            >
              Submit
            </Button>
          </div>
        </MuiDialogContent>
      </Dialog>
    </>
  );
};

export default Matched;
